import { render } from "./Home.vue?vue&type=template&id=ac0fa58c&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=ac0fa58c&lang=scss&scoped=true"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac0fa58c"]])

export default __exports__